export const BonusLabel = ({ bonus, className }: { bonus?: string | null; className?: string }) => (
  <>
    {bonus && (
      <div className={'flex justify-center border border-red rounded-[5px]' + ' ' + className}>
        <span className="text-red text-sm font-semibold">{bonus}</span>
      </div>
    )}
  </>
);
